import Vue from "vue";
import * as enums from "./enums";

Vue.filter("price", function(value) {
  if (value === undefined) {
    return "";
  }
  return (value / 100).toFixed(2);
});

Vue.filter("sex", function(value) {
  return value == 0 ? "男" : "女";
});

Vue.filter("shopType", function(value) {
  return enums.ShopType.getValue(value);
});

Vue.filter("payStatus", function(value) {
  return enums.PayStatus.getValue(value);
});

Vue.filter("orderStatus", function(value) {
  return enums.OrderStatus.getValue(value);
});

Vue.filter("shipStatus", function(value) {
  return enums.ShipStatus.getValue(value);
});

Vue.filter("payType", function(value) {
  return enums.PayType.getValue(value);
});

Vue.filter("tsFormat", function(value, format) {
  if (value === undefined || value === "") return "";
  value = parseInt(value);
  return new Date(value * 1000).format(format);
});

Vue.filter("tsFormatLong", function(value) {
  if (value === undefined || value === "") return "";
  value = parseInt(value);
  return new Date(value * 1000).format("yyyy/MM/dd hh:mm:ss");
});

Vue.filter("tsFormatDate", function(value) {
  if (value === undefined || value === "") return "";
  value = parseInt(value);
  return new Date(value * 1000).format("yyyy/MM/dd");
});

Vue.filter("courseTimes", function(value, ts) {
  if (!value || !ts) return "";
  value = Number(value);
  ts = Number(ts);
  let begin = new Date(value * 1000);
  let end = new Date(ts * 1000);
  if (
    begin.getFullYear() == end.getFullYear() &&
    begin.getDate() == end.getDate() &&
    begin.getMonth() == end.getMonth()
  ) {
    return begin.format("MM月dd日 hh:mm") + "~" + end.format("hh:mm");
  } else {
    return begin.format("MM月dd日") + "~" + end.format("MM月dd日");
  }
});
